import { ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Appconfig } from 'src/app/configurations/appconfig';
import { AppService } from 'src/app/providers/appservice/app.service';
import { CanvasService } from 'src/app/providers/canvas/canvas.service';
import { DashboardService } from 'src/app/providers/home/dashboard.service';
import { MessageService } from 'primeng/api';
import { SharedService } from 'src/app/modules/home/data.service';
import { LoaderService } from 'src/app/providers/loader/loader.service';
declare var DiagramEditor: any;
@Component({
  standalone: false,
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CanvasComponent implements OnInit, OnDestroy {
  isDataLoaded: boolean = false;
  canvasSource: any = '';
  @Input()
  canvasType: any;
  private setTimeoutOnCanvasSave: any;
  private setIntervalAutoSave: any;

  config: any = {
    "language": "",
    "configVersion": null,
    "customFonts": [],
    "libraries": "general;uml;er;bpmn;flowchart;basic;arrows2",
    "customLibraries": [
      "L.scratchpad"
    ],
    "plugins": [],
    "recentColors": [],
    "formatWidth": 240,
    "createTarget": false,
    "pageFormat": {
      "pageSize": {
        "pageWidth": "100px",
        "pageHeight": "100px",
      }
    },
    "autoSize": true,
    "search": true,
    "showStartScreen": true,
    "gridColor": "#d0d0d0",
    "darkGridColor": "#424242",
    "autosave": true,
    "resizeImages": null,
    "openCounter": 8,
    "version": 18,
    "unit": 1,
    "isRulerOn": false,
    "ui": "atlas",
    "darkMode": "auto",
    "maxImageSize": 900
  };
  ui: any;

  @ViewChild('canvasEditor', { static: false }) canvasEditor: any;
  @HostListener('window:canvasdatasave', ['$event'])
  onDataSave(event: any): void {
    if (event.detail.originalEvent !== 'autosave') {
      this.loaderService.show();
    }
    this.setTimeoutOnCanvasSave = setTimeout(() => {
      this.saveCanvas(this.canvasEditor.nativeElement.src, event.detail.originalEvent !== 'autosave');
      this.canvasService.isCanvasActive = false;
    }, 3000);
    // if(!event.detail.exit){
    // }
  }
  // @HostListener('window:canvasExit', ['$event'])
  // onExitCanvas(evt: any): void {
  // }

  constructor(private dashboardService: DashboardService, private canvasService: CanvasService, private appService: AppService,
    private sanitizer: DomSanitizer, private sharedService: SharedService, private loaderService: LoaderService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.sharedService.refreshScreen$.subscribe(response => {
      if (response === 'businesscapFramework') {
        // this.bussCap();
      }
      this.cdr.detectChanges();
    })
    this.init();

  }

  init() {
    const stratId = this.appService.currentActivatedFeature.strategyId;
    this.canvasService.getTabs(this.canvasType, stratId).subscribe({
      next: (tabs) => {
        if (tabs && tabs.length) {
          this.canvasService.getCanvasData(this.canvasType, stratId, tabs[0]._id).subscribe({
            next: (v) => {
              this.canvasSource = (v.canvas) ? v.canvas : Appconfig.defaultCanvas;
              this.isDataLoaded = true;
              document.getElementById('canvasEditor')?.setAttribute('src', this.canvasSource);
              this.cdr.detectChanges();
            },
            error: () => {
              this.cdr.markForCheck();
            }
          });
        } else {
          this.canvasSource = Appconfig.defaultCanvas;
          this.isDataLoaded = true;
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.cdr.markForCheck();
      }
    });
  }

  editDiagram() {
    this.canvasService.isCanvasActive = true;
    DiagramEditor.editElement(document.getElementById('canvasEditor'), this.config, this.ui, (data: any, draft: any, elt: any) => {
      this.canvasService.isCanvasActive = true;
      // this.saveCanvas(elt.currentSrc);
    });
  }

  saveCanvas(data: any, shouldShowToast: boolean) {
    this.canvasService.saveCanvasData({ canvas: data, type: this.canvasType }, this.appService.currentActivatedFeature.strategyId).subscribe({
      next: (v) => {
        this.cdr.detectChanges();
      },
      error: (e) => {
        this.sharedService.alertNotification('error', 'Unable to Save', e);
        this.cdr.markForCheck();
      },
      complete: () => {
        this.loaderService.hide();
        if (shouldShowToast) {
          this.sharedService.alertNotification('success', 'Saved Successfully', '');
        }
        this.cdr.markForCheck();
      }
    })
  }

  clearTimeout() {
    if (this.setTimeoutOnCanvasSave) {
      clearTimeout(this.setTimeoutOnCanvasSave);
    }
    if (this.setIntervalAutoSave) {
      clearTimeout(this.setIntervalAutoSave);
    }
  }

  ngOnDestroy() {
    DiagramEditor.stopEditingFrame();
    this.clearTimeout();
  }

}
